/* eslint-disable @typescript-eslint/naming-convention */
export const LANGUAGE_SET = 'LANGUAGE_SET';
import { fetchPost } from '../fetch';

export function setLanguage(code: string, noSafe?: boolean) {
    return async (dispatch: any) => {
        if (!noSafe) {
            await fetchPost('/api/userlanguage', undefined, { language: code });
        }
        return dispatch({ type: LANGUAGE_SET, code });
    };
}
